import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassCompleteTouchdownStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.PassComplete) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const startFragment =
            play.getFirstFragment(FootballState.Pass) ||
            play.getFirstFragment(FootballState.FieldGoalFakePass);

        const passCompleteFragment =
            play.getFirstFragment(FootballState.PassComplete) || fragment;

        const stats = [];
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: startFragment.passedBy.teamId,
                playerId: startFragment.passedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: startFragment.id,
                category: FootballStatsCategory.PASS,
                values: {
                    touchdowns: 1
                }
            },
            stats
        );

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: passCompleteFragment.receivedBy.teamId,
                playerId: passCompleteFragment.receivedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: passCompleteFragment.id,
                category: FootballStatsCategory.PASS_TARGET,
                values: {
                    touchdowns: 1
                }
            },
            stats
        );

        return stats;
    }
}
